import * as React from "react";
import PropTypes from "prop-types";

import { Notification } from "@lululemon/ecom-pattern-library-notification";
import { errorIcon } from "@lululemon/ecom-pattern-library-icons";

import styles from "../styles/image-error.module.scss";

const ImageError = ({
  errorText,
  className,
  brokenImageUrl,
  isThumb // TEMP - this should just be passed in as `className`
}) => {
  const errorStyle = isThumb
    ? styles.thumbnailImageError
    : styles.imageErrorRoot;

  return (
    <Notification
      type="message"
      icon={errorIcon}
      data-testid="image-error"
      visible
      className={`${errorStyle} ${className || ""}`}
      aria-label="Error Loading Photo"
      data-broken-url={brokenImageUrl}
    >
      {errorText && (
        <span
          data-testid="image-error-text"
          className={`${styles.imageErrorText} OneLinkTx`}
        >
          {errorText}
        </span>
      )}
    </Notification>
  );
};

ImageError.defaultProps = {
  errorText: "",
  className: "",
  brokenImageUrl: undefined
};

ImageError.propTypes = {
  errorText: PropTypes.string,
  className: PropTypes.string,
  brokenImageUrl: PropTypes.string,
  isThumb: PropTypes.bool
};

ImageError.displayName = "ImageError";

export default ImageError;
